import { ColorTokens, TagTypeTokens, } from '@voltmoney/schema';
import { tagTypeTokensMap as tagTypeTokensMapLight } from '../../light-mobile/tag';
export const tagTypeTokensMap = {
    [TagTypeTokens.DEFAULT]: {
        ...tagTypeTokensMapLight['DEFAULT'],
        labelColor: ColorTokens.Grey_200,
        bgColor: ColorTokens.Grey_500,
    },
    [TagTypeTokens.SECONDARY]: {
        ...tagTypeTokensMapLight['SECONDARY'],
        labelColor: ColorTokens.Grey_100,
        bgColor: ColorTokens.Black_20,
    },
    [TagTypeTokens.GRADIENT]: {
        ...tagTypeTokensMapLight['GRADIENT'],
        labelColor: ColorTokens.Grey_100,
        bgColor: ColorTokens.Grey_700,
    },
    [TagTypeTokens.PRIMARY]: {
        ...tagTypeTokensMapLight['PRIMARY'],
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.White,
    },
};
